import { SmokeFree } from "@mui/icons-material";
import { FormSelectCompleted } from "@/components/form/FormSelectCompleted";
import { FormMultipleAutoComplete } from "@/components/form/FormMultipleAutoComplete";
import { useMedicalCareContext } from "@/contexts/MedicalCareContext";
import { useState, useEffect } from "react";
import { useWatch } from "react-hook-form";
import {
    drugTypeLifetimeOptions,
    drugFrequencyPast12MonthsOptions,
} from "../constants/options";
import { CollapsibleSection } from "./CollapsibleSection";

export function DrugsFields() {
    const { control, setValue } = useMedicalCareContext();
    const [isOpen, setIsOpen] = useState(false);

    const drugTypeLifetime = useWatch({
        control,
        name: "Anthropometric.drugTypeLifetime",
        defaultValue: [],
    });

    const showDrugTypeLifetimeFields =
        drugTypeLifetime &&
        Array.isArray(drugTypeLifetime) &&
        drugTypeLifetime.length > 0 &&
        drugTypeLifetime.some((item: any) => item?.value && item?.value !== "");

    useEffect(() => {
        if (!showDrugTypeLifetimeFields) {
            setValue("Anthropometric.drugFrequencyPast12Months", "");
        }
    }, [showDrugTypeLifetimeFields, setValue]);

    return (
        <CollapsibleSection
            title="Drogas Ilícitas"
            icon={<SmokeFree sx={{ fontSize: "24px", color: "primary.main" }} />}
            isOpen={isOpen}
            onToggle={() => setIsOpen(!isOpen)}
        >
            <FormMultipleAutoComplete
                control={control}
                name="Anthropometric.drugTypeLifetime"
                label="Tipo de droga usado na sua vida"
                selectOptions={drugTypeLifetimeOptions}
                defaultValue={[]}
                variant="filled"
            />
            {showDrugTypeLifetimeFields && (
                <FormSelectCompleted
                    control={control}
                    name="Anthropometric.drugFrequencyPast12Months"
                    label="Quantas vezes você usou drogas ilícitas ou recreativas nos últimos 12 meses"
                    selectOptions={drugFrequencyPast12MonthsOptions}
                />
            )}
        </CollapsibleSection>
    );
}

